import React, { useState, useRef } from "react";
import PropTypes from "prop-types";
import styled from "styled-components/macro";
import { Menu, MenuButton, MenuLink, MenuList } from "@reach/menu-button";
import { useDispatch, useSelector } from "react-redux";
import { GetTopCategoriesAction } from "./actions";
import { getTopCategories } from "./selectors";
import {
  getAppURL,
  getCatalogId,
  getStoreId,
} from "../../AppContext/selectors";
import { emitMenuOpen, useMenuAutoClose } from "./menuBus";

const StyledMenuList = styled(MenuList)`
  background-color: var(--sv-color-dark-green);
  margin-top: 5px;
  box-shadow: 8px 8px 8px 0px rgba(0, 0, 0, 0.15);
  &::after {
    content: " ";
    position: absolute;
    bottom: 100%;
    left: 52px;
    top: -5px;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: transparent transparent var(--sv-color-dark-green) transparent;
  }
  &:focus {
    outline: none;
  }
  position: relative;
  z-index: 10;
  overflow: visible;
`;
const StyledMenuLink = styled(MenuLink)`
  font-family: var(--sv-font-sans);
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 44px;
  text-decoration: none;
  display: block;
  padding-left: 20px;
  padding-right: 20px;
  color: var(--sv-color-white) !important;
  border-bottom: 1px solid var(--sv-color-dark-gray);
  &[data-reach-menu-item][data-selected] {
    font-weight: bold;
  }
  &:focus {
    outline: none;
  }
`;

const CustomerSupportMenu = ({
  contactUsLink,
  helpLink,
  translationKey,
  currentFileRequired,
  activeMenu,
  activeClass,
}) => {
  const [clicked, setClicked] = useState(false);
  const [isLoaded, setLoaded] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const buttonRef = useRef(null);
  const menuId = "customer-support-menu";
  const dispatch = useDispatch();
  const storeId = useSelector(getStoreId);
  const catalogId = useSelector(getCatalogId);
  const availableItems = ["cotact-us", "help"];

  const handleMouseOver = !isLoaded
    ? () => {
        dispatch(GetTopCategoriesAction({ storeId, catalogId }));
        setLoaded(true);
      }
    : undefined;
  const handleButtonDown = () => {
    if (!clicked) setClicked(true);
  };
  const handleMenuUp = (e) => {
    if (clicked) setClicked(false);
  };
  const handleMenuOut = (e) => {
    if (clicked) setClicked(false);
  };
  const handleMenuClick = (e) => {
    if (clicked) {
      e.preventDefault();
      setClicked(false);
    }
  };
  const subItemsSelected = () => {
    return availableItems.findIndex((item) => item == activeMenu) !== -1;
  };
  useMenuAutoClose(menuId, isOpen, buttonRef);
  return (
    <Menu
      onOpen={() => {
        setIsOpen(true);
        emitMenuOpen(menuId);
      }}
      onClose={() => setIsOpen(false)}
    >
      <MenuButton
        ref={buttonRef}
        onFocus={handleMouseOver}
        onMouseOver={handleMouseOver}
        onMouseDown={handleButtonDown}
        className={`customer-support-btn header-support-button ${
          subItemsSelected() ? "headerMenuActive" : ""
        }`}
      >
        {translationKey(currentFileRequired["CUSTOMER_SUPPORT"])}
      </MenuButton>

      <StyledMenuList>
        <StyledMenuLink
          href={contactUsLink}
          onClick={handleMenuClick}
          onMouseUp={handleMenuUp}
          onMouseOut={handleMenuOut}
          className={activeClass("cotact-us")}
        >
          {translationKey(currentFileRequired["CONTACT_US"])}
        </StyledMenuLink>
        <StyledMenuLink
          href={helpLink}
          onClick={handleMenuClick}
          onMouseUp={handleMenuUp}
          onMouseOut={handleMenuOut}
          className={activeClass("help")}
        >
          {translationKey(currentFileRequired["HELP"])}
        </StyledMenuLink>
      </StyledMenuList>
    </Menu>
  );
};

CustomerSupportMenu.propTypes = {
  className: PropTypes.string,
};

export default CustomerSupportMenu;
